import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import useDelayUnmount from '~/shared/utils/useDelayUnmount';

const VisibilityWrapper = styled.div`
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
`;

function DelayUnmountWrapper({
  isMounted,
  delayTime = 300,
  children,
  toggleDisplayOnly = false,
}) {
  const shouldRender = useDelayUnmount(isMounted, delayTime);

  if (toggleDisplayOnly) {
    return (
      <VisibilityWrapper $isVisible={shouldRender}>
        {children}
      </VisibilityWrapper>
    );
  }

  return shouldRender ? children : null;
}

DelayUnmountWrapper.propTypes = {
  children: PropTypes.node,
  delayTime: PropTypes.number,
  isMounted: PropTypes.bool,
  toggleDisplayOnly: PropTypes.bool,
};

export default DelayUnmountWrapper;
